import { HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import {
  MatSnackBar,
  MatSnackBarRef,
  TextOnlySnackBar,
} from '@angular/material/snack-bar';
import { CapitalizePipe } from '../utils/pipes/capitalize.pipe';

@Injectable({ providedIn: 'root' })
export class SnackbarService {
  private readonly capitalize = new CapitalizePipe();

  constructor(private readonly snackbar: MatSnackBar) {}

  // ============================================
  // MÉTODO GENÉRICO
  // ============================================
  private show(
    type: 'info' | 'success' | 'warning' | 'error',
    title: string,
    msgOrError: string | HttpErrorResponse,
    timeout: number = 7500,
    action: string = '✖'
  ): MatSnackBarRef<TextOnlySnackBar> {
    const panelClass = ['snackbar', type, 'with-title'];

    const message = this.extractMessage(msgOrError);

    return this.snackbar.open(
      `${this.capitalize.transform(title)}\n${message}`,
      action,
      {
        duration: timeout,
        horizontalPosition: 'end',
        verticalPosition: 'bottom',
        panelClass,
      }
    );
  }

  // ============================================
  // EXTRACCIÓN DE MENSAJE
  // ============================================
  private extractMessage(msgOrError: string | HttpErrorResponse): string {
    if (typeof msgOrError === 'string') return msgOrError;

    if (msgOrError instanceof HttpErrorResponse && msgOrError.error?.message) {
      return msgOrError.error.message;
    }

    return 'Ha ocurrido un error desconocido, por favor intente nuevamente';
  }

  public info(
    title: string = 'Información',
    message: string | HttpErrorResponse,
    timeout?: number
  ) {
    return this.show('info', title, message, timeout);
  }

  public success(
    title: string = 'Éxito',
    message: string | HttpErrorResponse,

    timeout?: number
  ) {
    return this.show('success', title, message, timeout);
  }

  public warning(
    title: string = 'Advertencia',
    message: string | HttpErrorResponse,

    timeout?: number
  ) {
    return this.show('warning', title, message, timeout);
  }

  public error(
    title: string = 'Error',
    message: string | HttpErrorResponse,
    timeout?: number
  ) {
    return this.show('error', title, message, timeout);
  }
}
